import React from 'react';

const AchievementFilterItem = ({ filter, isActive, onClick }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`px-4 py-2 rounded-md text-sm font-medium transition-gaming ${
        isActive
          ? 'bg-primary text-primary-foreground shadow-gaming-sm'
          : 'bg-muted/40 text-muted-foreground hover:bg-muted hover:text-foreground'
      }`}
    >
      {filter?.label}
    </button>
  );
};

export default AchievementFilterItem;
